<div @enterUnfold
     class="dropdown-menu">
  <ng-content></ng-content>
</div>
